import React from 'react';
import { useDispatch } from 'react-redux';
import { i18next } from '@yola/ws-sdk';
import PropTypes from 'prop-types';
import dialogs from 'yola-editor/src/js/modules/dialogs';
import ResultDialog from '../components/result-dialog';

function PurchaseFailureDialogContainer({ captions, onBackButtonClick = null, onDialogCancel }) {
  const computedCaptions = {
    close: i18next.t('Dismiss'),
    ...captions,
  };

  const dispatch = useDispatch();

  function handleClose() {
    onDialogCancel();
    dispatch(dialogs.actions.hide());
  }

  return (
    <ResultDialog
      captions={computedCaptions}
      imgClass="dialog__img--failure"
      onBackButtonClick={onBackButtonClick}
      onClose={handleClose}
    />
  );
}

PurchaseFailureDialogContainer.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    close: PropTypes.string,
  }).isRequired,
  onBackButtonClick: PropTypes.func,
  onDialogCancel: PropTypes.func.isRequired,
};

export default PurchaseFailureDialogContainer;
